import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType {
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContributionFavorableDistance =
  {
    type: BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContributionOther =
  {
    type: BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.BONUS_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionWrongRoute =
  {
    type: BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionBeingLate =
  {
    type: BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionIncompatibleCar =
  {
    type: BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionOther =
  {
    type: BillingsOrderForwardTaxiTaxiDraftResponseItemContributionType.PENALTY_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContribution =
  | BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContributionFavorableDistance
  | BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContributionOther;

export type BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContribution =
  | BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionWrongRoute
  | BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionBeingLate
  | BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionIncompatibleCar
  | BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContributionOther;

export type BillingsOrderForwardTaxiTaxiDraftResponseItemContribution =
  | BillingsOrderForwardTaxiTaxiDraftResponseItemBonusContribution
  | BillingsOrderForwardTaxiTaxiDraftResponseItemPenaltyContribution;

export type BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionContractProducerTaxi =
  {
    displayName: string;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionTransportingOrderCargoOrder =
  {
    id: string;
    humanId: number;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionTransportingOrder =
  {
    cargoOrder: BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionTransportingOrderCargoOrder;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionContract =
  {
    model: string;
    distanceRate: number;
    haltingTimeRate: number;
    haltingTimeAfterMinutes: number;
    producerTaxi: BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionContractProducerTaxi;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingAction =
  {
    id: string;
    contract: BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionContract;
    transportingOrder: BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingActionTransportingOrder;
  };

export type BillingsOrderForwardTaxiTaxiDraftResponseItemBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: string | null;
  checkoutEventId: string | null;
  plannedDate: string | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsOrderForwardTaxiTaxiDraftResponseItem = {
  orderForwardingAction: BillingsOrderForwardTaxiTaxiDraftResponseItemOrderForwardingAction;
  billingNodes: BillingsOrderForwardTaxiTaxiDraftResponseItemBillingNode[];
  billingContributions: BillingsOrderForwardTaxiTaxiDraftResponseItemContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntryId: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
  date: Date;
  passengers: string[];
};

type BillingsOrderForwardTaxiTaxiDraftResponse =
  HttpResponse<BillingsOrderForwardTaxiTaxiDraftResponseItem>;

export default BillingsOrderForwardTaxiTaxiDraftResponse;
